import { render, staticRenderFns } from "./ConsultantCertificateSidebar.vue?vue&type=template&id=5b673880"
import script from "./ConsultantCertificateSidebar.vue?vue&type=script&lang=js"
export * from "./ConsultantCertificateSidebar.vue?vue&type=script&lang=js"
import style0 from "./ConsultantCertificateSidebar.vue?vue&type=style&index=0&id=5b673880&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports